import * as React from 'react';
import './SendRequestPageShell.scss';

interface Props {
  title: string;
  subtitle?: React.ReactNode;
  onBack: () => void;
  backLabel?: string;
  headerExtra?: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

export const SendRequestPageShell: React.FunctionComponent<Props> = props => {
  const { title, subtitle, onBack, backLabel = 'Back to event', headerExtra, children, className = '' } = props;

  return (
    <div className={`SendRequestPageShell${className ? ` ${className}` : ''}`}>
      <div className="SendRequestPageShell__header">
        <button type="button" className="SendRequestPageShell__back" onClick={onBack}>
          <span aria-hidden="true">←</span> {backLabel}
        </button>
        <div className="SendRequestPageShell__heading">
          <h3>{title}</h3>
          {subtitle ? <div className="SendRequestPageShell__subtitle">{subtitle}</div> : null}
        </div>
        {headerExtra ? <div className="SendRequestPageShell__headerExtra">{headerExtra}</div> : null}
      </div>
      <div className="SendRequestPageShell__body">{children}</div>
    </div>
  );
};
